export default __webpack_public_path__ + "static/media/womanImg.20b8e3e0.png";